import React, { useState, useEffect } from 'react';
import MySmallSelect from './MySmallSelect';
import margin from 'assets/scss/custom/margin.module.scss';
import { MenuItem } from '@material-ui/core';

const Variants = ({ variants, sku, loadProductData }) => {
  const [value, setValue] = useState('');

  useEffect(() => {
    const defaultValue =
      sku && variants && variants.length > 0
        ? variants.filter(item => {
            if (item.sku_id === sku) {
              return true;
            }
          })
        : '';
    const checkValue =
      defaultValue && defaultValue[0] && defaultValue[0].volume_label
        ? defaultValue[0].volume_label
        : '';
    setValue(checkValue);
  }, [variants]);

  const handleVariantsChange = value => {
    setValue(value);
    let selectedVariant = variants.filter(
      variant => variant.volume_label === value
    );
    let sku = selectedVariant[0].sku_id;
    loadProductData(sku);
  };
  return (
    <MySmallSelect
      label="Variant"
      variant="outlined"
      value={value}
      className={margin.bottom_sm}
      onChange={e => handleVariantsChange(e.target.value)}
    >
      {variants &&
        variants.map(variant => (
          <MenuItem key={variant._id} value={variant.volume_label}>
            {variant.volume_label}
          </MenuItem>
        ))}
    </MySmallSelect>
  );
};

export default Variants;
